import axios from "axios";
import settings from "../settings";
import { WORK_ORDER_CATEGORIES } from "../constants/workOrder";

const idTableHeader = {
    value: "id",
    text: "ID",
    align: "left",
    isSelected: true,
};

const buttonTableHeader = {
    value: "action",
    text: "",
    align: "end",
    isSelected: true,
    sortable: false,
};

const listSettingsColumns = [
    {
        value: "production_order_number",
        text: "Production order number",
        align: "left",
        isSelected: true,
    },
    {
        value: "line_number",
        text: "Line number",
        align: "left",
        isSelected: true,
    },
    {
        value: "production_date",
        text: "Production date",
        align: "left",
        isSelected: true,
    },
    {
        value: "product_name",
        text: "Product",
        align: "left",
        isSelected: true,
    },
    {
        value: "product_ean",
        text: "EAN",
        align: "left",
        isSelected: true,
        sortable: false,
    },
    {
        value: "operator",
        text: "Operator",
        align: "left",
        isSelected: true,
        sortable: false,
    },
    {
        value: "line_workers",
        text: "Line worker",
        align: "left",
        isSelected: true,
        sortable: false,
    },

    {
        value: "status",
        text: "Status",
        align: "left",
        isSelected: true,
    },

    {
        value: "sales_order_number",
        text: "Sales order number",
        align: "left",
        isSelected: false,
    },
    {
        value: "last_status_change",
        text: "Last status change",
        align: "left",
        isSelected: false,
    },
];
const inactiveTableHeaders = [
    {
        value: "id",
        text: "ID",
        align: "left",
        isSelected: true,
    },
    {
        value: "production_order_number",
        text: "Production order number",
        align: "left",
        isSelected: true,
    },
    {
        value: "line_number",
        text: "Line number",
        align: "left",
        isSelected: true,
    },
    {
        value: "production_date",
        text: "Production date",
        align: "left",
        isSelected: true,
    },
    {
        value: "product_name",
        text: "Product",
        align: "left",
        isSelected: true,
    },
    {
        value: "status",
        text: "Status",
        align: "left",
        isSelected: true,
    },
    {
        value: "action",
        text: "",
        align: "end",
        isSelected: true,
        sortable: false,
    },
];
const workOrderLineNumberTypes = [
    {
        type: "waffle_line",
        text: "Waffle line",
    },
    {
        type: "toaster",
        text: "Toaster + Polaris",
    },
    {
        type: "fryer_with_packing",
        text: "Fryer + Polaris",
    },
    {
        type: "fryer",
        text: "Fryer bread",
    },
    {
        type: "polaris",
        text: "Polaris",
    },
    {
        type: "all",
        text: "All",
    },
];

const workOrderLineNumbers = [
    {
        text: "Vahvliliin 1",
        value: "waffle_line_1",
    },
    {
        text: "Vahvliliin 2",
        value: "waffle_line_2",
    },
    {
        text: "Vahvliliin 3",
        value: "waffle_line_3",
    },
    {
        text: "Vahvliliin 4",
        value: "waffle_line_4",
    },
    {
        text: "Röster 1",
        value: "toaster_1",
    },
    {
        text: "Röster 2",
        value: "toaster_2",
    },
    {
        text: "Röster 2 + Polaris 3",
        value: "toaster_2+polaris_3",
    },
    {
        text: "Polaris 1",
        value: "polaris_1",
    },
    {
        text: "Polaris 3",
        value: "polaris_3",
    },
    {
        text: "Praadimisliin",
        value: "fryer",
    },
    {
        text: "Praadimisliin + Polaris 1",
        value: "fryer+polaris_1",
    },
    {
        text: "Praadimisliin + Polaris 3",
        value: "fryer+polaris_3",
    },
];

let initialState = {
    workOrders: [],
    inactiveWorkOrders: [],
    odooWorkOrders: [],
    loadingWorkOrders: false,
    loadingOdooWorkOrders: false,
    forcePullFromOdooModalVisible: false,
    activeWorkOrder: {
        downtimes_and_breakdowns: [],
        wastes: [],
        ingredients: [],
    },
    totalWorkOrders: 0,
    drawerOpen: false,
    workOrderGroupDrawer: false,
    activeWorkOrderGroup: {
        sales_order_number: null,
        estimated_time: null,
        production_order_number: null,
        production_batch_number: null,
        production_date: null,
        planned_quantity: null,
        product_id: null,
        product_code: null,
        product_name: null,
        product_ean: null,
    },
    loadingWorkOrderData: false,
    loadingWorkOrderGroupData: false,
    users: [],
    products: [],
    materials: [],
    requestSuccess: false,
    requestError: false,
    errorMessage: "",
    workOrderFiles: [],
    fileListFetched: false,
    searchWorkOrderString: "",
    tableOptions: null,
    listSettingsModal: false,
    listSettingsColumns: listSettingsColumns,
    inactiveTableHeaders: inactiveTableHeaders,
    workOrdersTableHeaders: [],
    statusForFiltering: ["plan", "in_progress", "done", "confirmed", "cancelled"],
    selectedWorkOrderTypeIndex: 0,
    workOrderLineNumberTypes: workOrderLineNumberTypes,
    workOrderLineNumbers: workOrderLineNumbers,
    selectedLineNumberType: null,
    durationConfirmationModal: false,
    durationConfirmationMessage: "",
};
let cancelDataRequest = null;
export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async fetchWorkOrders({ state, commit }, { options = null, search = null }) {
            await commit("setLoadingWorkOrders", true);
            if (cancelDataRequest) {
                cancelDataRequest();
            }
            const CancelToken = axios.CancelToken;
            let params = {
                search: search ? search : "",
                page: options && options.page ? options.page : 1,
                itemsPerPage: options && options.itemsPerPage ? options.itemsPerPage : 50,
                sortBy: options && options.sortBy[0] ? options.sortBy[0] : null,
                sortDesc: options && options.sortDesc ? options.sortDesc[0] : null,
                lineNumber: state.selectedLineNumberType,
            };
            try {
                let response = await axios.get(settings.api_url + "/work-orders", {
                    params,
                    cancelToken: new CancelToken((c) => {
                        cancelDataRequest = c;
                    }),
                });
                if (response.status === 200) {
                    cancelDataRequest = null;
                    let data = response.data;
                    commit("setWorkOrders", data.work_orders);
                    commit("setInactiveWorkOrders", data.inactive_work_orders);
                    commit("setTotalWorkOrders", data.total_work_orders_count);
                    commit("setUsers", data.users);
                    commit("setProducts", data.products);
                    commit("setMaterials", data.materials);
                    commit("setLoadingWorkOrders", false);

                    if (data.user_work_order_table_settings) {
                        commit("setMountedTableHeaders", data.user_work_order_table_settings);
                    } else {
                        commit("setWorkOrdersTableHeaders");
                    }
                }
            } catch (e) {
                console.log(e);
                commit("setLoadingWorkOrders", false);
            }
        },
        async fetchWorkOrderGroupData({ commit }, id) {
            await commit("setLoadingWorkOrderGroupData", true);

            try {
                let response = await axios.get(settings.api_url + "/work-order-group/" + id, {});
                if (response.status === 200) {
                    let data = response.data;
                    commit("setWorkOrderGroupData", data.work_order_group);
                    commit("setLoadingWorkOrderGroupData", false);
                }
            } catch (e) {
                console.log(e);
                commit("setLoadingWorkOrderGroupData", false);
            }
        },
        async getWorkOrder({ commit }, workOrderId) {
            await commit("setLoadingWorkOrderData", true);
            if (cancelDataRequest) {
                cancelDataRequest();
            }
            const CancelToken = axios.CancelToken;
            try {
                let response = await axios.get(`${settings.api_url}/work-order/${workOrderId}`, {
                    cancelToken: new CancelToken((c) => {
                        cancelDataRequest = c;
                    }),
                });
                if (response.status === 200) {
                    cancelDataRequest = null;
                    let data = response.data;
                    commit("setActiveWorkOrder", data.work_order);
                    commit("setLoadingWorkOrderData", false);
                    commit("setFileListFetched", false);
                }
            } catch (e) {
                console.log(e);
                commit("setLoadingWorkOrderData", false);
            }
        },
        async saveWorkOrder({ commit, state }, { workOrderId, ignoreOdoo }) {
            await commit("setLoadingWorkOrderData", true);
            if (cancelDataRequest) {
                cancelDataRequest();
            }
            const CancelToken = axios.CancelToken;

            try {
                let response = await axios.put(
                    `${settings.api_url}/work-order/${workOrderId}`,
                    {
                        work_order: state.activeWorkOrder,
                    },
                    {
                        cancelToken: new CancelToken((c) => {
                            cancelDataRequest = c;
                        }),
                        params: {
                            ignore_odoo: ignoreOdoo,
                        },
                    }
                );

                if (response.status === 200 && response.data.success === 1) {
                    cancelDataRequest = null;
                    commit("setLoadingWorkOrderData", false);
                } else {
                    commit("setRequestError", true);
                    let errorMsg = response.data.msg || "Failed";
                    commit("setErrorMessage", errorMsg);
                }
            } catch (e) {
                console.log(e);
                commit("setLoadingWorkOrderData", false);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
        },
        async deleteWorkOrderGroup({ commit, dispatch }, work_order_group_id) {
            try {
                const response = await axios.delete(settings.api_url + "/work-order-group/", {
                    params: { work_order_group_id: work_order_group_id },
                });

                if (response.status === 200) {
                    return { status: 1 };
                } else {
                    return { status: 0 };
                }
            } catch (e) {
                console.log(e);
            }
        },
        async deleteWorkOrder({ commit, dispatch }, work_order_id) {
            try {
                const response = await axios.delete(settings.api_url + "/work-order/", {
                    params: { work_order_id: work_order_id },
                });

                if (response.status === 200) {
                    return { status: 1 };
                } else {
                    return { status: 0 };
                }
            } catch (e) {
                console.log(e);
            }
        },
        async deleteWorkOrderFile({ commit, dispatch }, file_id) {
            try {
                const response = await axios.delete(settings.api_url + "/file/", {
                    params: { file_id: file_id },
                });

                if (response.status === 200) {
                    return { status: 1 };
                } else {
                    return { status: 0 };
                }
            } catch (e) {
                console.log(e);
            }
        },
        async submitWorkOrderGroupUpdate({ commit, dispatch }, payload) {
            commit("setLoadingWorkOrderGroupData", true);
            try {
                let response = await axios.put(settings.api_url + "/work-order-group/", { work_order_group: payload });
                if (response.status === 200 && response.data.success === 1) {
                    return response.data;
                }
            } catch (e) {
                console.log(e);
            }
            commit("setLoadingWorkOrderGroupData", false);
        },
        async createNewWorkOrder({ commit, dispatch }, work_order_group_id) {
            commit("setLoadingWorkOrderData", true);
            try {
                let response = await axios.post(settings.api_url + "/work-order/", {
                    work_order_group_id: work_order_group_id,
                });
                if (response.status === 200 && response.data.success === 1) {
                    return response.data.id;
                }
            } catch (e) {
                console.log(e);
            }
            commit("setLoadingWorkOrderData", false);
        },
        async sendNewComment({ commit, state }, comment) {
            commit("setLoadingWorkOrderData", true);
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                let payload = { comment };
                let response = await axios.post(
                    `${settings.api_url}/work-order-comment/${state.activeWorkOrder.id}`,
                    payload
                );
                if (response && response.data && response.data.success === 1) {
                    commit("setComments", response.data.comments);
                    commit("setRequestSuccess", true);
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
                commit("setLoadingWorkOrderData", false);
                return response.data;
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
                commit("setLoadingWorkOrderData", false);
            }
        },
        async deleteComment({ commit, state }, commentId) {
            commit("setLoadingWorkOrderData", true);
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                let response = await axios.delete(
                    `${settings.api_url}/work-order-comment/${state.activeWorkOrder.id}?item=${commentId}`
                );
                if (response && response.data && response.data.success === 1) {
                    commit("setComments", response.data.comments);
                    commit("setRequestSuccess", true);
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
            commit("setLoadingWorkOrderData", false);
        },
        async getWorkOrderFileList({ commit, state }) {
            if (!state.activeWorkOrder.id) {
                return;
            }
            try {
                commit("setRequestSuccess", false);
                commit("setRequestError", false);

                const response = await axios.get(`${settings.api_url}/work-order-file/`, {
                    params: {
                        act: "list",
                        work_order_id: state.activeWorkOrder.id,
                    },
                });

                if (response.status === 200 && response.data && response.data.files) {
                    commit("setWorkOrderFiles", response.data.files);
                } else {
                    commit("setRequestSuccess", false);
                }
            } catch (error) {
                commit("setRequestError", true);
            }
            commit("setFileListFetched", true);
        },
        async uploadFiles({ commit, state }, files) {
            commit("setLoadingWorkOrderData", true);
            commit("setRequestSuccess", false);
            commit("setRequestError", false);

            try {
                const formData = new FormData();

                for (let i = 0; i < files.length; i++) {
                    formData.append("files" + i, files[i]);
                }

                const response = await axios.post(
                    `${settings.api_url}/work-order-file/${state.activeWorkOrder.id}`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (response && response.data && response.data.success === 1) {
                    commit("setFiles", response.data.files);
                    commit("setRequestSuccess", true);
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }

                commit("setLoadingWorkOrderData", false);
                return response.data;
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
                commit("setLoadingWorkOrderData", false);
            }
        },
        async fetchWorkOrdersFromOdoo({ commit }) {
            commit("setLoadingOdooWorkOrders", true);
            try {
                let result = await axios.get(settings.api_url + "/work-order-odoo/");

                if (result && result.data && result.data.success === 1) {
                    commit("setOdooWorkOrders", result.data.wo_data);
                }
            } catch (e) {
                console.log("- COUNTRIES FETCH ERROR -");
                console.log(e);
                commit("setLoadingOdooWorkOrders", false);
            }
            commit("setLoadingOdooWorkOrders", false);
        },
        async submitForcePullWorkOrderFromOdooData({ commit, dispatch }, selectedItem) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            commit("setLoadingWorkOrders", true);
            try {
                let response = await axios.post(settings.api_url + "/work-order-odoo/", selectedItem);

                if (response.status === 200 && response.data.success === 1) {
                    commit("setRequestSuccess", true);
                } else {
                    commit("setRequestError", true);
                    commit("setLoadingWorkOrders", false);
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", false);
                commit("setLoadingWorkOrders", false);
            }
        },
    },
    mutations: {
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setRequestError(state, bool) {
            state.requestError = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        toggleWorkOrderGroupDrawer(state, isOpen) {
            state.workOrderGroupDrawer = isOpen;
        },
        setLoadingWorkOrders(state, bool) {
            state.loadingWorkOrders = bool;
        },
        setLoadingOdooWorkOrders(state, bool) {
            state.loadingOdooWorkOrders = bool;
        },
        setLoadingWorkOrderData(state, bool) {
            state.loadingWorkOrderData = bool;
        },
        setLoadingWorkOrderGroupData(state, bool) {
            state.loadingWorkOrderGroupData = bool;
        },
        setWorkOrders(state, value) {
            state.workOrders = value;
        },
        setInactiveWorkOrders(state, value) {
            state.inactiveWorkOrders = value;
        },
        setWorkOrderGroupData(state, value) {
            state.activeWorkOrderGroup = value;
        },
        setTotalWorkOrders(state, value) {
            state.totalWorkOrders = value;
        },
        setActiveWorkOrder(state, value) {
            state.activeWorkOrder = value;
        },
        setWorkOrderFiles(state, value) {
            state.workOrderFiles = value;
        },
        setUsers(state, value) {
            state.users = value;
        },
        setProducts(state, value) {
            state.products = value;
        },
        setMaterials(state, value) {
            state.materials = value;
        },
        setComments(state, value) {
            state.activeWorkOrder.comments = value;
        },
        setFiles(state, value) {
            state.activeWorkOrder.files = value;
        },
        updateActiveWorkOrderProperty(state, { field, value }) {
            if (field === "estimated_time") {
                const pattern = /:\d{1,2}$/;
                if (value && !pattern.test(value) && !value.includes(":")) {
                    value += ":00";
                }
            }
            state.activeWorkOrder = {
                ...state.activeWorkOrder,
                [field]: value,
            };
        },
        updateWorkOrderGroupProperty(state, { prop, value }) {
            state.activeWorkOrderGroup = {
                ...state.activeWorkOrderGroup,
                [prop]: value,
            };
        },
        updateActiveWorkOrderIngredientProperty(state, { field, value, index }) {
            if (typeof value === "object" && value !== null) {
                state.activeWorkOrder.ingredients[index] = {
                    id: null,
                    actual_quantity: null,
                    estimated_quantity: null,
                    product_batch: null,
                    product_code: value.code,
                    product_name: value.name,
                    product_id: value.id,
                    product_unit: null,
                };
            } else if (field === "item" && value !== null) {
                state.activeWorkOrder.ingredients[index] = {
                    id: null,
                    actual_quantity: null,
                    estimated_quantity: null,
                    product_batch: null,
                    product_code: null,
                    product_name: value,
                    product_id: null,
                    product_unit: null,
                };
            } else {
                state.activeWorkOrder.ingredients[index] = {
                    ...state.activeWorkOrder.ingredients[index],
                    [field]: value,
                };
            }
        },
        updateActiveWorkOrderLineWorkerProperty(state, { field, value, index }) {
            if (index <= state.activeWorkOrder.line_workers.length) {
                state.activeWorkOrder.line_workers[index] = {
                    id: null,
                    name: typeof value === "object" ? value.name : value,
                    user_id: typeof value === "object" ? value.id : null,
                };
            }
        },
        updateActiveWorkOrderOperatorProperty(
            state,
            { field, value, index, category = WORK_ORDER_CATEGORIES.CATEGORY_PRIMARY }
        ) {
            const name = typeof value === "object" ? value.name : value;
            const user_id = typeof value === "object" ? value.id : null;

            const operatorObj = { id: null, name, user_id, category };

            if (typeof index === 'number' && index >= 0 && index < state.activeWorkOrder.operators.length) {
                operatorObj.id = state.activeWorkOrder.operators[index].id;
                state.activeWorkOrder.operators[index] = operatorObj;
            } else {
                const existingIndex = state.activeWorkOrder.operators.findIndex((op) => {
                    const opCategory = op.category || WORK_ORDER_CATEGORIES.CATEGORY_PRIMARY;
                    return opCategory === category;
                });

                if (existingIndex !== -1) {
                    operatorObj.id = state.activeWorkOrder.operators[existingIndex].id;
                    state.activeWorkOrder.operators[existingIndex] = operatorObj;
                } else {
                    state.activeWorkOrder.operators.push(operatorObj);
                }
            }
        },
        updateActiveWorkOrderWasteProperty(state, { value, index, field, category }) {
            const wastes =
                category === WORK_ORDER_CATEGORIES.CATEGORY_PRIMARY
                    ? state.activeWorkOrder.wastes
                    : state.activeWorkOrder.wastes_secondary;
            if (index < wastes.length) {
                wastes[index] = {
                    ...wastes[index],
                    [field]: value,
                };
            }
        },
        updateActiveWorkOrderDowntimesAndBreakdownsProperty(state, { value, index, field, category }) {
            const dabs =
                category === WORK_ORDER_CATEGORIES.CATEGORY_PRIMARY
                    ? state.activeWorkOrder.downtimes_and_breakdowns
                    : state.activeWorkOrder.downtimes_and_breakdowns_secondary;
            dabs[index] = {
                ...dabs[index],
                [field]: value,
            };
        },
        updateActiveWorkOrderProductProperty(state, { product_name }) {
            state.activeWorkOrder.product_name = product_name;
            const selectedProduct = state.products.find((product) => product.name === product_name);
            if (selectedProduct) {
                state.activeWorkOrder.product_ean = selectedProduct.ean ?? null;
                state.activeWorkOrder.product_code = selectedProduct.code ?? null;
                state.activeWorkOrder.bags_in_box = selectedProduct.bags_in_box ?? 0;
                state.activeWorkOrder.boxes_on_pallet = selectedProduct.boxes_on_pallet ?? 0;
            }
        },
        updateActiveWorkOrderGroupProductProperty(state, { product_name }) {
            state.activeWorkOrderGroup.product_name = product_name;
            const selectedProduct = state.products.find((product) => product.name === product_name);
            if (selectedProduct) {
                state.activeWorkOrderGroup.product_id = selectedProduct.id ?? null;
                state.activeWorkOrderGroup.product_ean = selectedProduct.ean ?? null;
                state.activeWorkOrderGroup.product_code = selectedProduct.code ?? null;
            }
        },
        addNewLineWorker(state) {
            const newLineWorkerData = {
                id: null,
                name: null,
                user_id: null,
            };

            state.activeWorkOrder.line_workers.push(newLineWorkerData);
        },
        addNewOperator(state, category = WORK_ORDER_CATEGORIES.CATEGORY_PRIMARY) {
            const newOperatorData = {
                id: null,
                name: null,
                user_id: null,
                category: category,
            };

            state.activeWorkOrder.operators.push(newOperatorData);
        },
        removeLineWorker(state, index) {
            state.activeWorkOrder.line_workers.splice(index, 1);
        },
        removeOperator(state, index) {
            state.activeWorkOrder.operators.splice(index, 1);
        },
        addNewIngredient(state) {
            const newIngredientData = {
                id: null,
                actual_quantity: null,
                estimated_quantity: null,
                product_batch: null,
                product_code: null,
                product_name: null,
                product_unit: null,
                product_id: null,
                batch_change_time: null,
            };

            state.activeWorkOrder.ingredients.push(newIngredientData);
        },
        removeIngredient(state, index) {
            state.activeWorkOrder.ingredients.splice(index, 1);
        },
        addNewWaste(state, category = WORK_ORDER_CATEGORIES.CATEGORY_PRIMARY) {
            let wastes = state.activeWorkOrder.wastes;
            if (category === WORK_ORDER_CATEGORIES.CATEGORY_SECONDARY) wastes = state.activeWorkOrder.wastes_secondary;

            const newLineWasteData = {
                id: null,
                reason: null,
                quantity: null,
            };

            wastes.push(newLineWasteData);
        },
        addNewDowntimeAndBreakdown(state, category = WORK_ORDER_CATEGORIES.CATEGORY_PRIMARY) {
            const dabs =
                category === WORK_ORDER_CATEGORIES.CATEGORY_PRIMARY
                    ? state.activeWorkOrder.downtimes_and_breakdowns
                    : state.activeWorkOrder.downtimes_and_breakdowns_secondary;
            const newDowntimeAndBreakdownData = {
                id: null,
                reason: null,
                time_in_minutes: null,
                notes: null,
            };

            dabs.push(newDowntimeAndBreakdownData);
        },
        removeWaste(state, { index, category = WORK_ORDER_CATEGORIES.CATEGORY_PRIMARY }) {
            const wastes =
                category === WORK_ORDER_CATEGORIES.CATEGORY_PRIMARY
                    ? state.activeWorkOrder.wastes
                    : state.activeWorkOrder.wastes_secondary;
            wastes.splice(index, 1);
        },
        removeDowntimeAndBreakdown(state, { index, category = WORK_ORDER_CATEGORIES.CATEGORY_PRIMARY }) {
            const dabs =
                category === WORK_ORDER_CATEGORIES.CATEGORY_PRIMARY
                    ? state.activeWorkOrder.downtimes_and_breakdowns
                    : state.activeWorkOrder.downtimes_and_breakdowns_secondary;
            dabs.splice(index, 1);
        },
        resetActiveWorkOrderGroup(state) {
            state.activeWorkOrderGroup = initialState.activeWorkOrderGroup;
        },
        setFileListFetched(state, value) {
            state.fileListFetched = value;
        },
        setOdooWorkOrders(state, value) {
            state.odooWorkOrders = value;
        },
        setForcePullFromOdooModalVisible(state, value) {
            state.forcePullFromOdooModalVisible = value;
        },
        updateWorkOrderSearch(state, payload) {
            state.searchWorkOrderString = payload.term;
            this.dispatch("WorkOrderStore/fetchWorkOrders", {
                options: state.tableOptions,
                search: state.searchWorkOrderString,
            });
        },
        resetWorkOrderSearch(state) {
            state.searchWorkOrderString = "";
        },
        setWorkOrderSearch(state, value) {
            state.searchWorkOrderString = value;
        },
        toggleListSettingsModal(state) {
            state.listSettingsModal = !state.listSettingsModal;
        },
        toggleListSettingsColumn(state, item) {
            let column = state.listSettingsColumns.find((c) => c.value === item.value);
            column.isSelected = !column.isSelected;
        },
        setMountedTableHeaders(state, value) {
            state.workOrdersTableHeaders = value;

            let selected_array = state.workOrdersTableHeaders.map((x) => x.value);
            state.listSettingsColumns.forEach((x) => {
                x.isSelected = selected_array.includes(x.value);
            });
            let status = state.workOrdersTableHeaders.find((x) => x.value === "status");
            if (status && status.statuses) {
                state.statusForFiltering = status.statuses;
            }
        },
        setWorkOrdersTableHeaders(state) {
            state.workOrdersTableHeaders = [];
            state.workOrdersTableHeaders.push(idTableHeader);
            state.listSettingsColumns.map((x) => {
                if (x.isSelected) {
                    x.align = "left";
                    state.workOrdersTableHeaders.push(x);
                }
            });
            let status = state.workOrdersTableHeaders.find((x) => x.value === "status");
            if (status) {
                status.statuses = state.statusForFiltering;
            }
            state.workOrdersTableHeaders.push(buttonTableHeader);
        },
        setStatusForFiltering(state, value) {
            state.statusForFiltering = value;
        },
        setSelectedLineNumberType(state, value) {
            state.selectedLineNumberType = value;
        },
        setDurationConfirmationModal(state, bool) {
            state.durationConfirmationModal = bool;
        },
        setDurationConfirmationMessage(state, msg) {
            state.durationConfirmationMessage = msg;
        },
    },
    getters: {
        isToasterLineNumber: (state) => {
            const wo = state.activeWorkOrder;
            return wo?.id != null && wo.line_number?.includes("toaster");
        },
        isToaster1LineNumber: (state) => {
            const wo = state.activeWorkOrder;
            return wo?.id != null && wo.line_number?.includes("toaster_1") && wo.version > 1;
        },
        isToaster2LineNumber: (state) => {
            const wo = state.activeWorkOrder;
            return wo?.id != null && wo.line_number?.includes("toaster_2") && wo.version > 1;
        },
        isPackingLineNumber: (state) => {
            const wo = state.activeWorkOrder;
            return wo?.id != null && wo.line_number?.includes("polaris");
        },
        isToasterWorkOrder: (_, getters) => {
            return getters.isToasterLineNumber || getters.isPackingLineNumber;
        },
        isToasterWithPackingWorkOrder: (state) => {
            const wo = state.activeWorkOrder;
            return (
                wo?.id != null &&
                wo.line_number?.includes("toaster") &&
                wo.line_number?.includes("polaris") &&
                wo.version > 1
            );
        },
        isFryerWithPackingWorkOrder: (state) => {
            const wo = state.activeWorkOrder;
            return (
                wo?.id != null &&
                wo.version > 1 &&
                wo.line_number?.includes("fryer") &&
                wo.line_number?.includes("+") &&
                wo.line_number?.includes("polaris")
            );
        },
        isFryerOnlyWorkOrder: (state) => {
            const wo = state.activeWorkOrder;
            return (
                wo?.id != null && wo.line_number?.includes("fryer") && !wo.line_number?.includes("+") && wo.version > 1
            );
        },
        isMultiLineOrder: (_, getters) => {
            return getters.isToasterWithPackingWorkOrder || getters.isFryerWithPackingWorkOrder;
        },
        isPopcornProduction: (state) => {
            const wo = state.activeWorkOrder;
            return wo?.product_name != null && wo.product_name?.toLowerCase().includes("popcorn");
        },
    },
};
